import { render, staticRenderFns } from "./closeOrder.vue?vue&type=template&id=35da07cc&scoped=true"
import script from "./closeOrder.vue?vue&type=script&lang=js"
export * from "./closeOrder.vue?vue&type=script&lang=js"
import style0 from "./closeOrder.vue?vue&type=style&index=0&id=35da07cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da07cc",
  null
  
)

export default component.exports